/**
 * @desc 获取当前流程所有任务
 */
const URL = "/rantion-activiti";
import http, { updateResponse } from "@/http";
export type Response = defs.activiti.ResponseDto<Array<defs.activiti.BpmActivitiTaskInfoDto>>;
export function request(
  params: API.activiti.activiti.getBpmTaskInfos.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/activitiFacade/getTaskInfosBpm`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
